import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { DoctorService } from '../services/doctor.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { WindowreffService } from '../services/windowreff.service';
import { GlobalVariable } from '../core/global.variable';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PromocodeChatComponent } from './promocode-chat/promocode-chat.component';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.css']
})
export class ChatBotComponent implements OnInit {
  specialities: any = [
    'General Physician',
    'Pediatrician',
    'Gynaecologist',
    'Dentist',
    'Ophthalmologist',
    'Dermatologist',
    'Urologist',
    'ENT(Ear, Nose, Throat)',
    'Dietician',
    'Physiotherapist',
    'Neurologist',
    'Cardiologist',
    'Orthopedist',
    'Homeopath',
    'Ayurveda',
    'General Surgeon',
    'Gastroenterologist',
    'Psychologist'
  ];

  selectedSpecilaity: any = ''
  messages: any = []
  inputMessage: any = ''
  description: any = ''
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  messageEnable: boolean = false
  logindata: any
  username: any = '';
  payAmount = 99;

  constructor(private auth: AuthService,
    private doctorSvc: DoctorService,
    private toaster: ToastrService,
    private winRef: WindowreffService,
    private modalService: BsModalService,
    private router: Router) { }

  ngOnInit() {
    if (this.auth.isLoggedin && localStorage.getItem('usertype') == 'User') {
      this.username = JSON.parse(localStorage.getItem('logindata')).name ? JSON.parse(localStorage.getItem('logindata')).name : 'user'
    }
    if (localStorage.getItem('token')) {
      this.getPromo();
    }
    this.subscribeData();
  }

  subscribeData() {
    this.auth.isUserLogin.subscribe(data => {
      if (data) {
        this.getPromo();
      }
    });
  }

  getPromo() {
    let obj = {
      total_price: 1980
    }
    this.auth.postData('/PromoCodes/user_apply_promo_codes', obj).subscribe(res => {
      if (res['data'].booking_amount == 0) {
        this.payAmount = 0;
      } else {
        this.payAmount = res['data'].booking_amount;
      }
    }, error => {
      this.toaster.error(error.error.message, 'Error', {
        timeOut: 2000
      });
    })
  }

  setSpeciality(speciality) {
    this.selectedSpecilaity = speciality
    this.messages.push({ messageType: 'TEXT', sentBy: 'USER', message: this.selectedSpecilaity, pay: false })
    this.messageEnable = false
    setTimeout(() => {
      this.scrollToBottom()

    }, 1000);

    setTimeout(() => {
      this.messages.push({ messageType: 'TEXT', sentBy: 'BOT', message: "Describe your symptom or health problem so that you can be connected to specialist? Eg. Skin problem, Viral, Pregnancy", pay: false })
      this.messageEnable = true
    }, 1000);

    setTimeout(() => {
      this.scrollToBottom()

    }, 1000);
  }

  dontKnowSelected() {
    this.selectedSpecilaity = `I Don't Know`;
    this.setSpeciality(this.selectedSpecilaity);
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  scrollWhenClick() {

    setTimeout(() => {
      this.scrollToBottom()

    }, 1000);

  }

  sendMessage() {
    if (this.selectedSpecilaity != '' && this.inputMessage != '') {
      this.appPay();
    }
  }

  appPay() {
    if (this.selectedSpecilaity != '' && this.inputMessage != '') {
      setTimeout(() => {
        this.messages.push({ messageType: 'TEXT', sentBy: 'USER', message: this.inputMessage, pay: false })
        this.description = this.inputMessage
        this.inputMessage = ''
      }, 1000);

      setTimeout(() => {
        if (!this.payAmount) {
          this.messages.push({ messageType: 'TEXT', sentBy: 'BOT', message: 'Your online consultation with doctor is free', pay: true })
        } else {
          this.messages.push({ messageType: 'TEXT', sentBy: 'BOT', message: 'Pay Rs. 99 to Consult with Doctor', pay: true })
        }

        this.messageEnable = false
      }, 1000);

      setTimeout(() => {
        this.scrollToBottom()

      }, 1000);
    }
  }

  bookNow() {
    let id = new Date().getTime().toString();
    this.bookDoctor(id);
  }


  bookDoctor(transactionId) {
    if (!this.auth.isLoggedin) {
      document.getElementById('logintoggle_user').click()
    }
    else if (localStorage.getItem('usertype') == 'User') {
      let chatData = { chat_description: this.description, speciality: this.selectedSpecilaity, transactionId: transactionId };
      if (this.username) {
        chatData['name'] = this.username;
      }
      chatData['type'] = 'LIVE';
      this.auth.chatBooking(chatData).subscribe(res => {
        this.toaster.success('booking Successful', 'Success', {
          timeOut: 2000
        });
        if (res && res['data'] && res['data'].doctorId) {
          this.router.navigate(['/chat', res['data'].doctorId]);
        } else {
          this.router.navigate(['/user-orders']);
        }
        localStorage.setItem('tab', 'doctors')
      }, error => {
        this.toaster.error(error.error.message, 'Error', {
          timeOut: 2000
        });
      })
    }

  }

  payWithRazor() {

    if (!this.auth.isLoggedin) {
      document.getElementById('logintoggle_user').click()
    } else {
      let options: any = {
        "key": GlobalVariable.razor_pay_key,
        "amount": this.payAmount * 100,
        "name": "Daktarz",
        "description": "Pay for consult with Doctor",
        //  "image": "./assets/images/logo.png",
        "modal": {
          "escape": false
        },
        "theme": {
          "color": "#26abe3"
        }
      };
      options.handler = ((response) => {
        console.log(response)
        if (response.razorpay_payment_id) {
          this.bookDoctor(response.razorpay_payment_id);
        }
      });
      options.modal.ondismiss = (() => {
        //  this.loginService.SetLoader = false;
      });
      let rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();

    }
  }

  applyPromocode() {
    if (!this.auth.isLoggedin) {
      document.getElementById('logintoggle_user').click()
    } else {
      const modalRef = this.modalService.show(PromocodeChatComponent, {
        backdrop: 'static',
        keyboard: false
      });
      modalRef.content.payAmount = this.payAmount;
      modalRef.content.getPromo();
      modalRef.content.onClose.subscribe((result: any) => {
        this.payAmount = result as any;
      });
    }
  }

}
